import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const JobSeekerSearchByDecision = () => {
  const [jobDecision, setJobDecision] = useState('');
  const [jobSeekers, setJobSeekers] = useState([]);
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [employerDetails, setEmployerDetails] = useState({ name: 'Employer Name', email: 'employer@example.com' }); // Mock employer details
  const [fullDetails, setFullDetails] = useState(null);

  const fetchJobSeekers = async () => {
    if (!jobDecision) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}jobseeker/searchByDecision?jobDecision=${jobDecision}`);
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Failed to fetch job seekers');
      setJobSeekers(result.data || []);
    } catch (err) {
        console.log(err)
      setError(err.message);
      setJobSeekers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWishToEmploy = async (jobSeeker) => {
    setIsLoading(true);
    try {
      const token = Math.random().toString(36).substring(2); // Mock token generation
      const response = await fetch(`${process.env.REACT_APP_API_URL}jobseeker/employer/sendEmail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: jobSeeker.email,
          subject: 'Employment Interest',
          text: `${employerDetails.name} (${employerDetails.email}) wishes to view your details. Please accept or reject this request.`,
          acceptLink: `${window.location.origin}/accept-offer/${jobSeeker._id}/${token}`,
          rejectLink: `${window.location.origin}/reject-offer/${jobSeeker._id}/${token}`,
        }),
      });
      if (!response.ok) throw new Error('Failed to send email');
      alert('Email sent to job seeker for approval');
      setSelectedJobSeeker({ ...jobSeeker, pendingToken: token });
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const checkAcceptance = async (jobSeekerId, token) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}jobseeker/${jobSeekerId}/details?token=${token}`);
      const result = await response.json();
      if (response.ok && result.accepted) {
        setFullDetails(result.data);
      } else if (result.rejected) {
        setFullDetails(null);
        alert('Job seeker rejected the request');
      }
    } catch (err) {
      setError(err.message);
      setFullDetails(null);
    }
  };

  useEffect(() => {
    if (jobDecision) fetchJobSeekers();
  }, [jobDecision]);

  useEffect(() => {
    if (selectedJobSeeker?.pendingToken) {
      const interval = setInterval(() => checkAcceptance(selectedJobSeeker._id, selectedJobSeeker.pendingToken), 5000);
      return () => clearInterval(interval);
    }
  }, [selectedJobSeeker]);

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Search Job Seekers by Decision</h2>
      <div className="mb-4">
        <select
          value={jobDecision}
          onChange={(e) => setJobDecision(e.target.value)}
          className="p-2 border border-gray-300 rounded-md w-full sm:w-1/2"
        >
          <option value="">Select Job Decision</option>
          <option value="job-seeker">Job Seeker</option>
          <option value="job-changer">Job Changer</option>
        </select>
      </div>
      {isLoading && <p className="text-gray-500">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {jobSeekers.length > 0 && (
        <ul className="space-y-2">
          {jobSeekers.map((jobSeeker) => (
            <li key={jobSeeker._id} className="p-2 border rounded-md">
              <p><strong>Name:</strong> {`${jobSeeker.firstName} ${jobSeeker.lastName}`}</p>
              <p><strong>Email:</strong> {jobSeeker.email}</p>
              <p><strong>Job Decision:</strong> {jobSeeker.jobDecision}</p>
              <button
                onClick={() => handleWishToEmploy(jobSeeker)}
                className="mt-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                disabled={isLoading}
              >
                Wish to Employ
              </button>
              {selectedJobSeeker?._id === jobSeeker._id && selectedJobSeeker.pendingToken && (
                <p className="mt-2 text-yellow-600">Awaiting job seeker approval...</p>
              )}
              {fullDetails && fullDetails._id === jobSeeker._id && (
                <div className="mt-4 p-4 bg-gray-50 rounded-md">
                  <p><strong>Address:</strong> {fullDetails.address}</p>
                  <p><strong>State:</strong> {fullDetails.state}</p>
                  <p><strong>Local Government:</strong> {fullDetails.localGovernment}</p>
                  <p><strong>Phone:</strong> {fullDetails.phoneNumber}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default JobSeekerSearchByDecision;